import React from 'react';
import { bonuses } from '../data/bonuses';
import { SectionLabel } from './ui/SectionLabel';
const BONUS_SET = 'https://cdn.magicpatterns.com/uploads/wuManNq1BiJW4hx43im6jc/ChatGPT_Image_6_sept_2026,_20_04_18.png';
export function BonusesSection() {
  return <section className="w-full bg-ivory py-10 sm:py-14 lg:py-20" aria-labelledby="bonuses-heading" data-id="element-3" data-mp="vqjlj853zgsm">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-4" data-mp="qw5vzmd4o3vv">
        <div className="mx-auto max-w-2xl text-center" data-id="element-5" data-mp="14rzvjes0hgwb">
          <div className="flex justify-center" data-id="element-6" data-mp="zv13r2vtlm1a">
            <SectionLabel data-id="element-7" data-mp="zu7t3qtqqcdv">Also included</SectionLabel>
          </div>
          <h2 id="bonuses-heading" className="mt-3 font-serif text-[1.6rem] font-semibold uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-8" data-mp="1eice51g9mzzt">
            Go beyond the <span className="text-forest" data-id="element-9" data-mp="1njk8j8fnvgom">class plan.</span>
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-[0.95rem] leading-snug text-muted sm:text-lg" data-id="element-10" data-mp="1jigy51gducus">
            5 professional bonus resources designed to help you teach with more confidence,
            communicate more clearly and grow your yoga teaching practice.
          </p>
        </div>

        <img src={BONUS_SET} alt="The five premium bonus guides included with Yoga Teacher System: Yoga Business Starter Guide, Yoga Cueing & Transition Scriptbook, Yoga Student Retention Playbook, Yoga Business & Social Media Playbook and Yoga Studio & Collaboration Guide" className="mx-auto mt-6 w-full max-w-3xl" width={1800} height={900} loading="lazy" data-id="element-11" data-mp="3ttqg6mavmdo2" />

        <ul className="mt-6 grid gap-2 sm:grid-cols-2 sm:gap-3 lg:grid-cols-3" data-id="element-12" data-mp="lblrph4exdk8">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col items-center gap-2 rounded-2xl border border-sandDark bg-cream/70 px-3.5 py-4 text-center" data-id="element-13" data-mp="qa5f7lynmxep">
              <span className="text-[0.55rem] font-semibold uppercase tracking-label text-gold" data-id="element-14" data-mp="10a5zba4clhjy">
                Bonus {bonus.number}
              </span>
              <span className="font-serif text-[0.85rem] font-semibold uppercase leading-tight text-ink sm:text-[0.95rem]" data-id="element-15" data-mp="5m5v8fpwpnoa">
                {bonus.title}
              </span>
              <span className="text-[0.78rem] leading-snug text-muted sm:text-sm" data-id="element-16" data-mp="kd4xl905ffzf">
                {bonus.short}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}